import { createSlice } from "@reduxjs/toolkit";

// Define the initial value for the slice state
const initialState = {
  isLoading: false,
};
export const LoadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    showLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

// Export the generated action creators for use in components
export const { showLoading } = LoadingSlice.actions;

// Export the slice reducer for use in the store configuration
export default LoadingSlice.reducer;
